import { motion } from "framer-motion";
import aboutMain from "../Img/about_section_fin.png";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4 } },
};

const AboutMainSection = () => {
    return (
        <motion.div
            className="about-main-section-smco"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >
            <motion.div className="about-main-container-smco" variants={staggerContainer}>
                <motion.div className="about-main-left-smco" variants={scrollReveal}>
                    <motion.img src={aboutMain} alt="Money Vision  - Trusted Loan Services" variants={scrollReveal} className="animate__animated animate__zoomInLeft" />
                    <motion.div className="about-main-left-border-smco animate__animated animate__zoomInLeft" variants={scrollReveal} ></motion.div>
                </motion.div>
                <motion.div className="about-main-right-smco" variants={staggerContainer}>
                    <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                        <span className="horizontal-line"></span>About Money Vision 
                    </motion.h2>
                    <motion.p className="about-main-right-text-smco" variants={scrollReveal}>
                        A Loan Direct Selling Agent (DSA) company functions as an intermediary that connects potential borrowers with lenders like banks and Non-Banking Financial Companies (NBFCs). These companies find customers for financial products such as personal, home, and business loans. They assist in the loan application process, including documentation and verification, and earn a commission on approved loans. The company, and its agents, act as a bridge to expand a financial institution's market reach and help customers access loans. 
                    </motion.p>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default AboutMainSection;
